import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, first, tap } from 'rxjs';
import {
  CreateLeaveRequestPayload,
  LeaveRequest,
} from './leave-request.model';
import { LeaveRequestApproverContract } from '@pt/shared';

@Injectable({
  providedIn: 'root',
})
export class LeaveRequestsService {
  private readonly pendingCountSubject = new BehaviorSubject<number>(0);
  readonly pendingCount$ = this.pendingCountSubject.asObservable();

  constructor(private readonly http: HttpClient) {}

  create(payload: CreateLeaveRequestPayload): Observable<LeaveRequest> {
    return this.http.post<LeaveRequest>('/api/leave-requests', payload);
  }

  getMine(): Observable<LeaveRequest[]> {
    return this.http.get<LeaveRequest[]>('/api/leave-requests/me');
  }

  getApprovers(): Observable<LeaveRequestApproverContract[]> {
    return this.http.get<LeaveRequestApproverContract[]>(
      '/api/leave-requests/approvers'
    );
  }

  isApprover(): Observable<boolean> {
    return this.http.get<boolean>('/api/leave-requests/approver/status');
  }

  getPending(): Observable<LeaveRequest[]> {
    return this.http
      .get<LeaveRequest[]>('/api/leave-requests/pending')
      .pipe(tap((requests) => this.pendingCountSubject.next(requests.length)));
  }

  getHistory(): Observable<LeaveRequest[]> {
    return this.http.get<LeaveRequest[]>('/api/leave-requests/history');
  }

  respond(
    id: number,
    approved: boolean,
    comment?: string
  ): Observable<LeaveRequest> {
    return this.http
      .post<LeaveRequest>(`/api/leave-requests/${id}/respond`, {
        approved,
        comment,
      })
      .pipe(tap(() => this.refreshPendingCount()));
  }

  refreshPendingCount(): void {
    this.getPending().pipe(first()).subscribe();
  }

  resetPendingCount(): void {
    this.pendingCountSubject.next(0);
  }
}
